import { useEffect, useRef, type RefObject } from 'react';
import { trapFocusWithinOverlay } from '@/components/ui/focusTrap';
import { isSmallScreen } from './mediaQueries';

const COMPOSER_SELECTOR = '[data-assistant-composer]';
const TAB_KEY = 'Tab';

export function useAssistantPanelFocus(
  panelRef: RefObject<HTMLElement | null>,
  isOpen: boolean
): void {
  const openerRef = useRef<HTMLElement | null>(null);

  useEffect(
    function moveFocusWithThePanel() {
      if (isOpen === false) {
        return undefined;
      }
      const activeElement = document.activeElement;
      openerRef.current = activeElement instanceof HTMLElement ? activeElement : null;
      const panel = panelRef.current;
      const composer = panel === null ? null : panel.querySelector<HTMLElement>(COMPOSER_SELECTOR);
      if (composer !== null) {
        composer.focus();
      }
      function keepFocusInsideOnSmallScreens(event: KeyboardEvent) {
        if (event.key === TAB_KEY && isSmallScreen()) {
          trapFocusWithinOverlay(panelRef.current, event);
        }
      }
      document.addEventListener('keydown', keepFocusInsideOnSmallScreens);
      return function returnFocusToOpener() {
        document.removeEventListener('keydown', keepFocusInsideOnSmallScreens);
        const opener = openerRef.current;
        if (opener !== null && opener.isConnected) {
          opener.focus();
        }
      };
    },
    [isOpen, panelRef]
  );
}
